module.exports = __webpack_public_path__ + "img/wechat-pay-example.ea8592c4.png";